module.exports = __webpack_public_path__ + "static/img/coin-modal.97445fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/coin-modal.png
// module id = rEG5
// module chunks = 215